<div class="navbar-container" style="font-family: DBHeavent !important">
    <!-- ALERT -->
    <div class="alert-container">
      <div id="alert_container" class="alert-container">
        <div class="container">
          <div class="alert-wrapper">
            <div class="alert-message d-flex align-items-center">
              <!-- <img src="./public/warning-icon.png" alt="" /> -->
              <!-- Render Alert Content From API -->
              <div id="alert_content"></div>
            </div>
            <div class="alert-action d-flex">
              <button id="button_close_alert"
                      type="button"
                      class="btn btn-close d-flex align-items-center">
                <!-- <img src="./public/close-alert-icon.png" alt="" /> -->
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- TOPBAR -->
    <div class="d-none d-xl-flex">
      <div class="d-none d-xl-flex topbar-container" mode="light">
        <div class="container-xl">
          <div class="topbar-content row">
            <div class="d-flex align-items-center justify-content-end col px-0">
              <div class="ml-4">
                <a class="link-back" href="/contact">
                  <p class="mb-0">
                    <svg width="20"
                         height="16"
                         viewBox="0 0 20 16"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                         class="icons">
                      <path fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0 2a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2zm18 1.869V14H2V3.869l8 5.333 8-5.333zM17.197 2H2.803L10 6.798 17.197 2z"
                            fill="#fff"></path>
                    </svg>
                    <span class="lang" key="contactUs">ติดต่อเรา</span>
                  </p>
                </a>
              </div>
              <div class="ml-4">
                <a class="link-back" href="/faq">
                  <p class="mb-0 lang">
                    <svg width="20"
                         height="20"
                         viewBox="0 0 20 20"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                         class="icons">
                      <path fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10zm11 4v2H9v-2h2zm-1 4c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM6 8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.283-.79 1.973-1.56 2.646C11.712 11.283 11 11.905 11 13H9c0-1.821.942-2.543 1.77-3.178C11.42 9.324 12 8.879 12 8c0-1.1-.9-2-2-2s-2 .9-2 2H6z"
                            fill="#fff"></path>
                    </svg>
                    <span class="lang" key="faqs">คำถามที่พบบ่อย</span>
                  </p>
                </a>
              </div>
              <div class="ml-4 d-flex align-items-center">
                <p class="mb-0 cursor-pointer language-selector">
                  <svg width="18"
                       height="18"
                       viewBox="0 0 18 18"
                       fill="none"
                       xmlns="http://www.w3.org/2000/svg"
                       class="icons fill-none">
                    <path d="M9 17A8 8 0 109 1a8 8 0 000 16zM1.455 6.333h15.089M1.456 11.667h15.089"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"></path>
                    <path d="M9 16.785c1.841 0 3.334-3.485 3.334-7.785 0-4.3-1.493-7.785-3.334-7.785C7.16 1.215 5.667 4.7 5.667 9c0 4.3 1.492 7.785 3.333 7.785z"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"></path>
                  </svg>
                  <span class="language thai" data-lang="th-locale">ไทย</span> | 
                  <span class="language english" data-lang="en-locale">EN</span> | 
                  <span class="language chinese" data-lang="cn-locale">中文</span>
                </p>
              </div>
              <div class="ml-4">
                <a class="link-back" href="/log-in">
                  <p class="mb-0">
                    <svg width="20"
                         height="20"
                         viewBox="0 0 20 20"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                         class="icons">
                      <path fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10 12a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
                            fill="#fff"></path>
                      <path fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15.926 18.056A9.986 9.986 0 0020 10c0-5.523-4.477-10-10-10S0 4.477 0 10a9.986 9.986 0 004.211 8.155A9.96 9.96 0 0010 20a9.96 9.96 0 005.926-1.944zm-.697-2.001a8 8 0 10-10.457 0A5.998 5.998 0 0110 13c2.243 0 4.2 1.231 5.229 3.055zm-1.672 1.113a4 4 0 00-7.114 0A7.967 7.967 0 0010 18c1.278 0 2.485-.3 3.557-.832z"
                            fill="#fff"></path>
                    </svg>
                    <span class="lang" key="register">
                      สมัครสมาชิก / เข้าสู่ระบบ
                    </span>
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <header mode="light" class="navbar-wrapper">
      <nav class="p-0 h-100 navbar navbar-expand-xl navbar-dark">
        <div class="container-xl px-0">
          <div class="navbar-brand ml-2 ml-md-4 ml-xl-0">
            <a class="link-back" href="/home">
              <!-- <svg width="100"
                   height="32"
                   viewBox="0 0 140 32"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg"
                   class="logo">
                <path d="M23.456 15.336c.733.519.942 1.451.418 2.177-.523.725-1.466.932-2.199.518L9.53 10.259 3.56 13.368v3.108c0 .933-.837 1.762-1.78 1.762-.942 0-1.78-.829-1.78-1.762V1.762C0 .829.838 0 1.78 0c.943 0 1.78.829 1.78 1.762V9.74l9.058-4.767L21.675.207c.838-.414 1.78-.103 2.2.622.418.829.104 1.762-.629 2.176L12.775 8.497l10.68 6.84zM43.037 25.077c.314-.103.628-.103.837.208.21.31.105.725-.104 1.036l-3.142 2.072 3.142 2.073c.209.207.314.518.104.829-.21.207-.523.31-.837.103l-3.56-2.383-3.665 2.383c-.315.104-.629.104-.838-.207-.105-.31-.105-.621.21-.829l3.245-2.176-3.246-2.176c-.314-.207-.419-.518-.21-.829.21-.31.63-.31.839-.31l3.664 2.486 3.56-2.28zM103.036 27.772c1.257 0 2.199.414 2.095 2.072 0 1.658-.943 2.073-2.095 2.073h-6.701c-.314 0-.628-.311-.628-.622s.314-.622.628-.622h6.597c.419 0 .837-.103.837-.829 0-.622-.314-.829-.837-.829h-5.131c-1.152 0-2.094-.414-2.094-2.072 0-1.658.942-2.073 2.094-2.073h6.701c.315 0 .629.311.629.622 0 .31-.314.622-.629.622h-6.596c-.524 0-.943.207-.943.829 0 .621.419.829.943.829h5.13zM118.429 27.772h-5.13c-.524 0-.838-.208-.838-.83 0-.621.419-.828.838-.828h6.596c.315 0 .629-.311.629-.622s-.314-.622-.629-.622h-6.701c-1.152 0-2.094.415-2.094 2.073s.942 2.072 2.094 2.072h5.131c.523 0 .942.207.942.83 0 .725-.419.828-.942.828h-6.597c-.314 0-.628.311-.628.622 0 .31.314.622.628.622h6.806c1.152 0 2.094-.415 2.094-2.073-.104-1.658-1.047-2.072-2.199-2.072zM52.356 16.373c0-.83-.628-1.451-1.466-1.451H33.403c-.942 0-1.57-.622-1.57-1.554v-2.695h16.23c.838 0 1.466-.621 1.466-1.45 0-.83-.628-1.451-1.466-1.451h-16.23V4.87c0-.932.628-1.554 1.57-1.554H50.89c.838 0 1.466-.622 1.466-1.45 0-.83-.628-1.452-1.466-1.452H32.565c-2.513-.103-4.293 1.658-4.293 4.146v9.119c0 2.487 1.78 4.248 4.294 4.248H50.89c.838 0 1.466-.725 1.466-1.554zM28.587 26.114H21.57c-.42 0-.629.207-.629.518v1.14h6.493c.314 0 .628.31.628.621s-.314.622-.628.622h-6.492v.933c0 .414.209.622.628.622h7.015c.315 0 .629.31.629.621s-.314.622-.628.622h-7.33c-.943 0-1.676-.622-1.676-1.658v-3.627c0-.932.628-1.658 1.676-1.658h7.33c.314 0 .628.311.628.622 0 .31-.314.622-.628.622zM82.304 26.114h7.015c.314 0 .629-.311.629-.622s-.315-.622-.629-.622h-7.33c-1.047 0-1.675.726-1.675 1.658v3.627c0 1.036.733 1.658 1.676 1.658h7.33c.313 0 .628-.31.628-.622 0-.31-.315-.621-.629-.621h-7.015c-.42 0-.629-.208-.629-.622v-.933h6.493c.314 0 .628-.31.628-.622 0-.31-.314-.621-.629-.621h-6.492v-1.14c0-.311.21-.518.629-.518zM136.44 1.762c0-.933.838-1.762 1.78-1.762 1.047 0 1.78.829 1.78 1.762v11.813c0 2.487-1.78 4.248-4.293 4.248h-17.278c-.837 0-1.466-.621-1.466-1.45 0-.83.629-1.451 1.466-1.451h16.44c.943 0 1.571-.622 1.571-1.554V10.88h-16.649c-2.513 0-4.294-1.762-4.294-4.249v-4.87c0-.933.838-1.762 1.781-1.762.942 0 1.78.829 1.78 1.762v4.56c0 .932.628 1.554 1.57 1.554h15.812V1.762zM80.838 17.41c.419-.726.104-1.762-.629-2.177l-9.214-4.559 5.13.104c2.933 0 5.34-1.14 5.34-5.285 0-4.145-2.407-5.285-5.34-5.285H58.64c-.943 0-1.78.829-1.78 1.761v14.404c0 .933.837 1.762 1.78 1.762.942 0 1.78-.829 1.78-1.762V3.317h15.078c1.257 0 2.304.518 2.304 2.28 0 1.761-1.047 2.28-2.304 2.28h-10.47c-.839 0-1.467.62-1.467 1.45 0 .622.314 1.14.838 1.347l14.345 7.357c.733.415 1.676.104 2.095-.621zM74.555 26.943c0 1.658-.942 2.072-2.094 2.072h-2.094l3.664 1.762c.315.103.524.518.315.829-.105.31-.524.518-.838.31l-5.655-2.9a.569.569 0 01-.314-.519c0-.31.314-.622.629-.622h4.083c.524 0 .943-.207.943-.932 0-.726-.42-.933-.943-.933h-5.864v5.181a.712.712 0 01-.733.726.712.712 0 01-.733-.726v-5.595c0-.415.315-.726.733-.726h6.807c1.152 0 2.094.415 2.094 2.073z"
                      fill="#fff"></path>
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M57.173 24.87h-6.806a.712.712 0 00-.733.726v5.595c0 .415.314.726.733.726.418 0 .733-.311.733-.726v-2.176h6.073c1.152 0 2.094-.414 2.094-2.072 0-1.555-.942-2.073-2.094-2.073zm-.21 3.005H51.1v-1.761h5.863c.524 0 .943.207.943.932 0 .622-.419.83-.943.83z"
                      fill="#fff"></path>
                <path d="M110.89 5.596c0 4.145-2.408 5.285-5.34 5.285l-4.922-.207 9.215 4.559c.733.415 1.047 1.45.628 2.176-.419.726-1.466 1.036-2.199.622l-14.345-7.357c-.524-.208-.838-.726-.838-1.348 0-.829.628-1.45 1.466-1.45h10.471c1.257 0 2.304-.519 2.304-2.28 0-1.762-1.047-2.28-2.304-2.28H89.948v13.16c0 .933-.838 1.762-1.78 1.762-.943 0-1.78-.829-1.78-1.761V2.073c0-.933.837-1.762 1.78-1.762h17.382c2.932 0 5.34 1.14 5.34 5.285z"
                      fill="#fff"></path>
              </svg> -->
              <svg width="171" height="57" viewBox="0 0 171 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_15724_319619)">
                <path d="M161.42 56.1507H9.20998C4.52998 56.1507 0.72998 52.3707 0.72998 47.7107V9.1707C0.72998 4.5107 4.52998 0.720703 9.20998 0.720703H161.42C166.1 0.720703 169.9 4.5007 169.9 9.1607V47.7007C169.9 52.3607 166.1 56.1407 161.42 56.1407V56.1507ZM9.20998 3.5907C6.11998 3.5907 3.60998 6.0907 3.60998 9.1607V47.7007C3.60998 50.7707 6.11998 53.2707 9.20998 53.2707H161.42C164.51 53.2707 167.02 50.7707 167.02 47.7007V9.1707C167.02 6.1007 164.51 3.6007 161.42 3.6007H9.20998V3.5907Z" fill="white"/>
                <path d="M161.42 56.87H9.21C4.13 56.87 0 52.76 0 47.7V9.17C0 4.11 4.13 0 9.21 0H161.42C166.5 0 170.63 4.11 170.63 9.17V47.71C170.63 52.77 166.5 56.88 161.42 56.88V56.87ZM9.21 1.45C4.93 1.45 1.45 4.91 1.45 9.17V47.71C1.45 51.97 4.93 55.43 9.2 55.43H161.41C165.69 55.43 169.16 51.97 169.16 47.71V9.17C169.16 4.91 165.68 1.45 161.41 1.45H9.21ZM161.42 54.01H9.21C5.72 54.01 2.88 51.19 2.88 47.71V9.17C2.88 5.7 5.72 2.87 9.21 2.87H161.42C164.91 2.87 167.75 5.69 167.75 9.17V47.71C167.75 51.18 164.91 54.01 161.42 54.01ZM9.21 4.31C6.52 4.31 4.33 6.49 4.33 9.17V47.71C4.33 50.38 6.52 52.57 9.21 52.57H161.42C164.11 52.57 166.3 50.39 166.3 47.71V9.17C166.3 6.5 164.11 4.31 161.42 4.31H9.21Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M110.45 41.6994C111.27 42.9294 112.95 43.2994 114.2 42.4694L149.29 18.8594C150.52 18.0394 150.86 16.3894 150.04 15.1594C149.21 13.8894 147.57 13.5594 146.31 14.3594L111.22 37.9794C109.96 38.7894 109.62 40.4694 110.45 41.6994Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M150.03 41.6994C149.21 42.9294 147.53 43.2994 146.28 42.4694L111.19 18.8594C109.96 18.0394 109.62 16.3894 110.44 15.1594C111.27 13.8894 112.91 13.5594 114.17 14.3594L149.26 37.9794C150.52 38.7894 150.86 40.4694 150.03 41.6994Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M57.7899 15.28C57.1399 14.06 55.6199 13.6 54.3899 14.25L25.7199 29.43V16.74C25.7199 15.21 24.4699 13.97 22.9299 13.97C21.3899 13.97 20.1399 15.21 20.1399 16.74V40.06C20.1399 41.59 21.3899 42.83 22.9299 42.83C24.4699 42.83 25.7199 41.58 25.7199 40.06V35.08L35.1299 30.1L54.1999 42.43C55.3599 43.18 56.9199 42.85 57.6799 41.69C58.4299 40.54 58.1099 38.98 56.9399 38.24L40.1999 27.42L56.7399 18.66C57.9799 18.01 58.4399 16.5 57.7899 15.27" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M72.7199 19.2298H100.2C101.5 19.2298 102.57 18.1798 102.57 16.8698C102.57 15.5598 101.51 14.5098 100.2 14.5098H71.3199C67.3799 14.5098 64.6299 17.2498 64.6299 21.1798V35.6098C64.6299 39.5298 67.3799 42.2798 71.3199 42.2798H100.2C101.5 42.2798 102.57 41.2298 102.57 39.9198C102.57 38.6098 101.51 37.5498 100.2 37.5498H72.7199C71.2099 37.5498 70.2099 36.5298 70.2099 35.0598V30.7498H95.7399C97.0399 30.7498 98.1099 29.6998 98.1099 28.3898C98.1099 27.0798 97.0499 26.0298 95.7399 26.0298H70.2099V21.7298C70.2099 20.2498 71.2099 19.2398 72.7199 19.2298Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_15724_319619">
                <rect width="170.62" height="56.88" fill="white"/>
                </clipPath>
                </defs>
                </svg>
            </a>
          </div>
          <button aria-label="Toggle navigation"
                  type="button"
                  class="navbar-toggler-wrapper navbar-toggler"
                  data-toggle="collapse"
                  data-target="#navbarContent">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="pb-3 pb-xl-0 collapse navbar-collapse collapse-wrapper"
               id="navbarContent">
            <div class="collapse-style">
              <ul class="w-100 justify-content-between align-items-center navbar-nav">
                <li class="d-lg-block d-xl-none w-100 nav-item">
                  <a class="link-back" href="/track">
                    <button class="mb-3 track-parcel-button btn btn-block lang"
                            key="trackParcel">
                      ติดตามพัสดุ
                    </button>
                  </a>
                </li>
                <li class="nav-item-wrapper nav-item">
                  <h5 class="mb-xl-0 d-flex justify-content-between align-items-center p-2 css-1ck9r2h">
                    <div class="d-none d-xl-block">
                      <div class="py-2 dropdown">
                        <span data-toggle="dropdown"
                              aria-expanded="false"
                              aria-haspopup="true"
                              id="dropdownMenuButton">
                          <a class="lang" key="domesticShipping">จัดส่งภายในประเทศ</a>
                        </span>
                        <div tabindex="-1"
                             role="menu"
                             aria-hidden="true"
                             class="css-83rms1 dropdown-menu"
                             aria-labelledby="dropdownMenuButton">
                          <!-- <a class="link-backkf" href="/services/kerryfriends">
                            <li class="sub-menu-item nav-item">
                              <span class="lang css-1kom0nh" key="kerryfriends">
                              </span>
                            </li></a> -->
                            <a class="link-back" href="/services/locker-service">
                              <li class="sub-menu-item nav-item">
                                <span class="lang css-1kom0nh" key="locker">
                                </span>
                              </li></a>
                          <!-- <a class="link-back" href="/services/am">
                <li class="sub-menu-item nav-item lang" key="am">
                  ส่งพัสดุด่วนก่อนเที่ยง
                </li></a
                > -->
                <a class="link-back" href="/services/cod">
                  <li class="sub-menu-item nav-item lang"
                      key="cod">
                    บริการเก็บเงินปลายทาง
                  </li>
                </a>
                <a class="link-back" href="/services/easy-ship">
                  <li class="sub-menu-item nav-item lang"
                      key="easyShip">
                    อีซี่ชิป
                  </li>
                </a>
                <a class="link-back" href="/services/extra-care">
                  <li class="sub-menu-item nav-item lang"
                      key="extraCare">
                    เอ็กซ์ตร้าแคร์
                  </li>
                </a>
                <a class="link-back" href="/services/dropoff">
                  <li class="sub-menu-item nav-item lang"
                      key="kerryDropoff">
                    ดรอป ออฟ
                  </li>
                </a>
                <a [href]="getClaimUrl()">
                  <li class="sub-menu-item nav-item lang"
                      key="onlineClaims">
                    เคลมสินค้า
                  </li>
                </a>
                <a class="link-back"
                   href="/services/pickup-request">
                  <li class="sub-menu-item nav-item lang"
                      key="pickUpRequest">
                    เรียกรถเข้ารับพัสดุ
                  </li>
                </a>
                <a class="link-back"
                   href="/services/price-estimation">
                  <li class="sub-menu-item nav-item lang"
                      key="priceEstimation">
                    คำนวณค่าจัดส่งพัสดุ
                  </li>
                </a>
                <a class="link-back"
                   href="/services/self-collection">
                  <li class="sub-menu-item nav-item lang"
                      key="scl">
                    รับพัสดุด้วยตัวเอง
                  </li>
                </a>
                <a class="link-back"
                   href="/exchange-service">
                    <div class="menu-item-with-new">
                  <li class="sub-menu-item nav-item lang"
                      key="ecs">
                    บริการรับพัสดุด้วยตัวเอง
                  </li>
                  <span class="lang item-new" key="new">ใหม่</span>
                  </div>
                </a> 
            </div>
          </div>
        </div>
        <div class="d-xl-none w-100">
          <div class="d-flex align-items-center justify-content-between w-100"
               data-toggle="collapse"
               href="#collapseExample"
               role="button"
               aria-expanded="false"
               aria-controls="collapseExample">
            <a class="lang" key="domesticShipping">จัดส่งภายในประเทศ</a>
            <!-- <a class="lang" key="services">บริการของเรา</a> -->
            <div class="collapse-arrow">
              <svg width="24"
                   height="24"
                   viewBox="0 0 24 24"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M6 15l6-6 6 6"
                      stroke="#DC742B"
                      stroke-linecap="round"
                      stroke-linejoin="round"></path>
              </svg>
            </div>
          </div>
          <div class="mt-2 collapse" id="collapseExample">
              <!-- <a class="link-backkf" href="/services/kerryfriends">
                <li class="sub-menu-item nav-item">
                  <span class="lang css-1kom0nh" key="kerryfriends">
                  </span>
                </li>
                </a> -->
                <a class="link-back" href="/services/locker-service">
                  <li class="sub-menu-item nav-item">
                    <span class="lang css-1kom0nh" key="locker">
                    </span>
                  </li>
                  </a>
            <!-- <li class="sub-menu-item nav-item">
              <a href="/services/am"
                 class="lang link-back"
                 key="am">ส่งพัสดุด่วนก่อนเที่ยง</a>
            </li> -->
            <li class="sub-menu-item nav-item">
              <a href="/services/cod"
                 class="lang link-back"
                 key="cod">บริการเก็บเงินปลายทาง</a>
            </li>
            <li class="sub-menu-item nav-item">
              <a href="/services/easy-ship"
                 class="lang link-back"
                 key="easyShip">อีซี่ชิป</a>
            </li>
            <li class="sub-menu-item nav-item">
              <a href="/services/extra-care"
                 class="lang link-back"
                 key="extraCare">เอ็กซ์ตร้าแคร์</a>
            </li>
            <li class="sub-menu-item nav-item">
              <a href="/services/dropoff"
                 class="lang link-back"
                 key="kerryDropoff">ดรอป ออฟ</a>
            </li>
            <li class="sub-menu-item nav-item">
              <a [href]="getClaimUrl()"
                 class="lang"
                 key="onlineClaims">เคลมสินค้า</a>
            </li>
            <li class="sub-menu-item nav-item">
              <a href="/services/pickup-request"
                 class="lang link-back"
                 key="pickUpRequest">เรียกรถเข้ารับพัสดุ</a>
            </li>
            <li class="sub-menu-item nav-item">
              <a href="/services/price-estimation"
                 class="lang link-back"
                 key="priceEstimation">คำนวณค่าจัดส่งพัสดุ</a>
            </li>
            <li class="sub-menu-item nav-item">
              <a href="/services/self-collection"
                 class="lang link-back"
                 key="scl">รับพัสดุด้วยตัวเอง</a>
            </li>
             <li class="sub-menu-item nav-item">
               <div class="menu-item-with-new">
              <a href="/exchange-service"
                 class="lang link-back"
                 key="ecs">บริการรับพัสดุด้วยตัวเอง</a>
                <span class="lang item-new" key="new">ใหม่</span>
                </div>
            </li>
          </div>
        </div>
        </h5>
        </li>
        <li class="nav-item-wrapper nav-item">
          <h5 class="mb-xl-0 d-flex justify-content-between align-items-center p-2 css-1ck9r2h">
            <a href="/international-shipping"
               class="lang link-back"
               key="internationalShipping">บริการจัดส่งระหว่างประเทศ</a>
          </h5>
        </li>
        <li class="nav-item-wrapper nav-item">
          <h5 class="mb-xl-0 d-flex justify-content-between align-items-center p-2 css-1ck9r2h">
            <a href="/where-we-are"
               class="lang link-back"
               key="location">จุดที่ตั้ง</a>
          </h5>
        </li>
        <li class="nav-item-wrapper nav-item">
          <h5 class="mb-xl-0 d-flex justify-content-between align-items-center p-2 css-1ck9r2h">
            <a href="/kerry-club"
            class="lang link-back" 
            key="kerryClub">KEX CLUB</a>
          </h5>
        </li>
        <li class="nav-item-wrapper nav-item">
          <h5 class="mb-xl-0 d-flex justify-content-between align-items-center p-2 css-1ck9r2h">
            <a href="https://investor.th.kex-express.com"
               class="lang"
               key="investorRelations"
               target="_blank">นักลงทุนสัมพันธ์</a>
          </h5>
        </li>
        <li class="d-none d-xl-inline-block nav-item">
          <a class="link-back" href="/track">
            <button class="btn-outline text-uppercase track-parcel-button-xl btn lang"
                    key="trackParcel">
              ติดตามพัสดุ
            </button>
          </a>
        </li>
        </ul>
  </div>

  <div class="d-xl-none nav-item-menus-wrapper">
    <div class="mr-4 d-flex my-2">
      <a class="link-back" href="/contact">
        <p class="mb-0">
          <svg width="20"
               height="16"
               viewBox="0 0 20 16"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
               class="icons">
            <path fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 2a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2zm18 1.869V14H2V3.869l8 5.333 8-5.333zM17.197 2H2.803L10 6.798 17.197 2z"
                  fill="#fff"></path>
          </svg>
          <span class="lang" key="contactUs">ติดต่อเรา</span>
        </p>
      </a>
    </div>
    <div class="mr-4 d-flex my-2">
      <div class="mb-0">
        <p class="mb-0 cursor-pointer language-selector">
          <svg width="18"
               height="18"
               viewBox="0 0 18 18"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
               class="icons fill-none">
            <path d="M9 17A8 8 0 109 1a8 8 0 000 16zM1.455 6.333h15.089M1.456 11.667h15.089"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"></path>
            <path d="M9 16.785c1.841 0 3.334-3.485 3.334-7.785 0-4.3-1.493-7.785-3.334-7.785C7.16 1.215 5.667 4.7 5.667 9c0 4.3 1.492 7.785 3.333 7.785z"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"></path>
          </svg>
          <span class="language thai" data-lang="th-locale">ไทย</span> | 
          <span class="language english" data-lang="en-locale">EN</span> | 
          <span class="language chinese" data-lang="cn-locale">中文</span>
        </p>
      </div>
    </div>
    <div class="mr-4 d-flex my-2">
      <a class="link-back" href="/faq">
        <p class="mb-0">
          <svg width="20"
               height="20"
               viewBox="0 0 20 20"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
               class="icons">
            <path fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10zm11 4v2H9v-2h2zm-1 4c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM6 8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.283-.79 1.973-1.56 2.646C11.712 11.283 11 11.905 11 13H9c0-1.821.942-2.543 1.77-3.178C11.42 9.324 12 8.879 12 8c0-1.1-.9-2-2-2s-2 .9-2 2H6z"
                  fill="#fff"></path>
          </svg>
          <span class="lang" key="faqs">คำถามที่พบบ่อย</span>
        </p>
      </a>
    </div>
    <div class="mr-4 d-flex my-2">
      <a class="link-back" href="/log-in">
        <p class="mb-0">
          <svg width="20"
               height="20"
               viewBox="0 0 20 20"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
               class="icons">
            <path fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10 12a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
                  fill="#fff"></path>
            <path fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.926 18.056A9.986 9.986 0 0020 10c0-5.523-4.477-10-10-10S0 4.477 0 10a9.986 9.986 0 004.211 8.155A9.96 9.96 0 0010 20a9.96 9.96 0 005.926-1.944zm-.697-2.001a8 8 0 10-10.457 0A5.998 5.998 0 0110 13c2.243 0 4.2 1.231 5.229 3.055zm-1.672 1.113a4 4 0 00-7.114 0A7.967 7.967 0 0010 18c1.278 0 2.485-.3 3.557-.832z"
                  fill="#fff"></path>
          </svg>
          <span class="lang" key="register">
            สมัครสมาชิก / เข้าสู่ระบบ
          </span>
        </p>
      </a>
    </div>
  </div>
  </div>
  </div>
  </nav>
  </header>
  </div>